import React from "react";
import { Container } from 'semantic-ui-react'
import { translate } from "../../addons/Translate";

import NavTop from "./NavTop";

const Header = (props) => {
	const { restaurant } = window;

	return (
		<div id="Header" className={window.restaurant.settings.color_schema} style={{backgroundImage: `url("${window.restaurant.settings.background}")`}}>
			<NavTop />

			<div id="HeaderContent">
				<Container textAlign="center">
					<div className="join">{translate("xxltable.header")}</div>
					<div className="restaurant">{restaurant.name}</div>
					{ window.options.base_url !== 'gastro' && <div className="address">{restaurant.city} - {restaurant.country}</div> }
				</Container>
			</div>
		</div>
	);
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/ui/Header.js